import React from 'react';
import './ui.css';

export default function PageHeader({ title, subtitle, icon, actions, children }) {
  return (
    <header className="ax-page-header">
      <div className="ax-page-header__titles">
        <h1 className="ax-page-title">
          {icon ? <i className={icon} aria-hidden="true" /> : null}
          {title}
        </h1>
        {subtitle ? <p className="ax-page-subtitle">{subtitle}</p> : null}
        {children}
      </div>
      {actions ? <div className="ax-page-header__actions">{actions}</div> : null}
    </header>
  );
}
